// extracted by mini-css-extract-plugin
export default {"agents":"Agents-module--agents--b0350","list":"Agents-module--list--5ff0e","agent":"Agents-module--agent--b38b7"};